




























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import request from '@/assets/js/http';
import downloadStreamFile from '@/assets/js/downloadStreamFile';
import { reportList } from '@/api/report';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: { ...mapGetters(['userInfo']) }
})
class Report extends Vue {
  @Prop()
  reportIndex;

  @Prop()
  url;

  @Prop()
  columns;

  @Prop()
  scrollWidth;

  @Prop()
  requestData;

  @Prop()
  downloadUrl;

  @Prop()
  fileName;

  @Prop()
  projectNameTmp;

  userInfo: any;
  data: any[] = [];
  height: number = 0;
  page: number = 1;
  pageSize: number = 50;
  total: number = 0;
  pageSizeOptions: any[] = ['10', '25', '50', '100', '200'];
  current: number = 1;
  requestObj: object = {};
  hasPermission: boolean = false;
  loading: boolean = false;

  @Watch('requestData', { immediate: true })
  handleChange(data) {
    this.requestObj = { ...data };
    this.current = 1;
    this.page = 1;
    this.getList(true);
  }

  @Watch('projectNameTmp')
  projectNameChange(data) {
    this.projectNameTmp = data;
  }

  mounted() {
    this.height = window.innerHeight - 400;
    window.onresize = () => {
      return (() => {
        this.height = window.innerHeight - 400;
      })();
    };
    this.getPermission();
    // this.getList();
  }

  async getPermission() {
    try {
      let res = await reportList();
      if (res.code === 200) {
        // const exportList = res.data[this.reportIndex].export.map(_ => _.id);
        const exportList = res.data.filter(_ => _.id === this.reportIndex + 1)[0].export.map(_ => _.id);
        const { id } = this.userInfo || {};
        this.hasPermission = exportList.indexOf(id) > -1;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getList(flag = false) {
    try {
      this.loading = true;
      let data;
      if (flag) {
        data = { ...this.requestObj, page: this.page, pageSize: this.pageSize };
      } else {
        data = { page: this.page, pageSize: this.pageSize };
      }
      let res;
      res = await request({
        url: this.url,
        method: 'post',
        data
      });
      this.loading = false;
      if (res.code === 200) {
        this.data = res.data.list;
        this.total = res.data.total;
      }
    } catch (err) {
      console.log(err);
    }
  }

  changePage(page, pageSize) {
    this.page = page;
    this.getList(true);
  }

  onShowSizeChange(current, pageSize) {
    this.pageSize = pageSize;
    this.getList(true);
  }

  queryList() {
    this.current = 1;
    this.page = 1;
    if (this.projectNameTmp !== this.requestObj['projectName']) {
      this.requestObj['projectName'] = this.projectNameTmp;
    }

    // vote原始表 空的字段不传
    if (this.reportIndex === 5 && this.projectNameTmp === '') {
      delete this.requestObj['projectName'];
    }

    this.getList(true);
  }

  async exportReport() {
    try {
      // 第二个参数是传入的data
      downloadStreamFile(this.downloadUrl, '', this.fileName);
    } catch (err) {
      console.log(err);
    }
  }

  getPopupContainer(trigger) {
    return trigger.parentElement;
  }
}
export default Report;
